module.exports = __webpack_public_path__ + "img/icon_aplicaciones_over.866e250c.svg";